<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Global Configuration</h5>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->

      <div class="card-body">
        <div class="text-center">
          <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
        </div>
        <form class="needs-validation form-create-category" @submit.prevent="updateGlobalConfiguration">
          <div class="d-block form-group">
            <label for="enableLatency">
              Enable Latency
              <input id="enableLatency" type="checkbox" v-model="globalConfiguration.enableLatency" name="enableLatency" />
            </label>
          </div>
        
          
          <div class="text-center">
            <button type="submit" class="mr-2 btn btn-primary" :disabled="checking">
              Update Config
              <i class="fa fa-spinner fa-spin" v-if="checking"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalConfigurationApi from '@/api/global-configuration'
import utils  from "@/utils"

export default {
  name: "GlobalConfiguration",
  data() {
    return {
      globalConfiguration: {
        enableLatency: false,
      },
      isLoading: false,
      checking: false,
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      const globalConfiguration = await GlobalConfigurationApi.getGlobalConfiguration(this.globalConfiguration)
      this.globalConfiguration = globalConfiguration
      this.isLoading = false
    },
    async updateGlobalConfiguration() {
      try {
        await GlobalConfigurationApi.updateGlobalConfiguration(this.globalConfiguration)
        utils.showToastSuccess("Global configuration updated!")
      } catch (e) {
        utils.showToastError(e.bodyText)
      }
      
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
